import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { ProtectedRoute } from './ProtectedRoute';

import LoginPage from '../pages/LoginPage';
import TutorReports from '../pages/TutorReports';
import ReportForm from '../pages/ReportForm';
import HeadReports from '../pages/HeadReports';
import ViceReports from '../pages/ViceReports';
import Archive from '../pages/Archive';
import Profile from '../pages/Profile';
import DashboardPage from '../pages/DashboardPage';
import TutorsPage from '../pages/TutorsPage';
import TutorDetailsPage from '../pages/TutorDetailsPage';

export default function AppRoutes() {
    return (
        <Routes>
            {/* Public */}
            <Route path="/login" element={<LoginPage />} />

            {/* Auth required */}
            <Route element={<ProtectedRoute />}>
                <Route element={<Layout />}>

                    {/* Tutor / Common */}
                    <Route path="/" element={<TutorReports />} />
                    <Route path="/reports/new" element={<ReportForm />} />
                    <Route path="/reports/:id/edit" element={<ReportForm />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/archive" element={<Archive />} />

                    {/* Head + Vice */}
                    <Route
                        element={<ProtectedRoute allowedRoles={['head', 'vice']} />}
                    >
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/tutors" element={<TutorsPage />} />
                        <Route path="/tutors/:id" element={<TutorDetailsPage />} />
                    </Route>

                    {/* Head only */}
                    <Route
                        element={<ProtectedRoute allowedRoles={['head']} />}
                    >
                        <Route path="/head/approvals" element={<HeadReports />} />
                    </Route>

                    {/* Vice only */}
                    <Route
                        element={<ProtectedRoute allowedRoles={['vice']} />}
                    >
                        <Route path="/vice/approvals" element={<ViceReports />} />
                    </Route>

                </Route>
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}
